/* @flow */
import moment from 'moment-timezone';
import { connect } from 'react-redux';

import { timezone as getTimezone } from 'modules/settings/getters.js';

type LocalDatetimeProps = {
  timezone: string,
  timestamp: number | string | Date, // Anything moment can handle
  format?: string,
};

// Calling code is welcome to override this as needed.
const defaultFormat = 'YYYY-MM-DD h:ma z';

const mapState = state => ({
  timezone: getTimezone(state),
});
export const LocalDatetime = connect(mapState)(
  ({ timezone, timestamp, format = defaultFormat }: LocalDatetimeProps) => {
    return moment(timestamp)
      .tz(timezone)
      .format(format);
  }
);



// WEBPACK FOOTER //
// ./web_modules/trustar/components/LocalDatetime.js